import { Button, Card, Skeleton } from 'antd';
import clsx from 'clsx';

const LoadingCard = () => {
    return (
        <Card
            hoverable
            className={clsx('product-card loading')}
            classNames={{
                body: 'p-2',
            }}
            cover={
                <div className="product-cover">
                    <Skeleton.Image
                        active
                        className='w-full h-full'
                    />
                </div>
            }
        >
            <Skeleton.Input active size="small" className='mb-2 w-9rem max-h-1rem' />
            <Skeleton.Input active size="small" className='mb-2 w-full max-h-1rem' />

            <div className="flex justify-content-between align-items-center mb-4">
                <Skeleton.Input active size="small" className='max-h-1rem' />
            </div>

            <div className="mb-1">
                <Skeleton.Input active size="small" block />
            </div>

            <Button block disabled size='small' />
        </Card>
    );
};

export default LoadingCard;